import { render } from "./SkillsAssessmentDataTable.vue?vue&type=template&id=72621d71&scoped=true"
import script from "./SkillsAssessmentDataTable.vue?vue&type=script&lang=js"
export * from "./SkillsAssessmentDataTable.vue?vue&type=script&lang=js"

import "./SkillsAssessmentDataTable.vue?vue&type=style&index=0&id=72621d71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72621d71"]])

export default __exports__